import type { GoogleSignupRequest } from '@/api/auth/type'
import { createContext, useContext, useState } from 'react'

export const SignupProgressContext = createContext<{
  signupInfo: GoogleSignupRequest | null
  onChangeSignupInfo: <T extends keyof GoogleSignupRequest>(
    key: T,
    value: GoogleSignupRequest[T],
  ) => void
}>({
  signupInfo: null,
  onChangeSignupInfo: () => {},
})

export const useSignupProgressContext = () => useContext(SignupProgressContext)

const signupInfoInitialState: GoogleSignupRequest = {
  userType: 'CREATOR',
  name: '',
  phoneNumber: '',
  corpName: '',
  serviceAgree: false,
  marketingAgree: false,
  verificationKey: '',
  secret: '',
  token: '',
}

export const SignupProgressProvider = ({
  children,
  token,
}: {
  children: React.ReactNode
  token: string
}) => {
  const [signupInfo, setSignupInfo] = useState<GoogleSignupRequest>({
    ...signupInfoInitialState,
    token,
  })

  const onChangeSignupInfo = (
    key: keyof GoogleSignupRequest,
    value: GoogleSignupRequest[keyof GoogleSignupRequest],
  ) => {
    setSignupInfo(prev => ({ ...prev, [key]: value }))
  }

  return (
    <SignupProgressContext.Provider
      value={{
        signupInfo,
        onChangeSignupInfo,
      }}
    >
      {children}
    </SignupProgressContext.Provider>
  )
}
